export const Services = {"SEARCH_FILTER":{"path":"https://apiposeidon.azurewebsites.net/","method":"GET","descrp":"Search Filter"}}